import configuratorReducer from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer";
import * as actions from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import get from 'lodash/get';

export default function (state, action) {

    switch (action.type) {

        case actions.RECEIVE_CLIENT_DATA: {
            if (action.data.success === false) {
                return state;
            }
            const clientData = action.data;
            return {
                ...state,
                client: {
                    ...clientData,
                    theme: {
                        ...clientData.theme,
                        highlightColor: '#000000', // if client theme has black then can be replaced with color variable
                        font: "/font/KlavikaWebBasic/KlavikaWebBasic.woff",
                    },
                },
            };
        }
        case actions.RECEIVE_CONFIGURATION: {
            const statusCode = get(action, "data.code");
            if (statusCode && statusCode === 401) {
                return {
                    ...state,
                    hasNoAccess: true,
                    errorMessage: get(action, "data.message"),
                    calculationIsEnabled: false,
                };
            } else {
                return configuratorReducer({...state, hasNoAccess: false}, action);
            }
        }
    }
    return configuratorReducer(state, action);
}
